import { countDecimal } from "../services/math";
import React from "react";
import { ITaxType } from "../interfaces/ITaxes";
import FormSwitchWithText from "../yoello-lib/modules/dynamicForms/FormComponents/FormSwitchWithText";
import FormTextBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";
import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import InputAdornment from '@material-ui/core/InputAdornment';
import FormSelect from "../yoello-lib/modules/dynamicForms/FormComponents/FormSelect";

export function taxesForm(t: (key: string) => string, isEdit = false): IDynamicFormRow[] {
    return [
        {

            label: "taxes.form.taxName",
            keyName: "tax_band_name",
            Component: FormTextBox,
            disabled: isEdit,
            registerOptions:
            {
                required: true
            },
            inputProperties: {
                variant: 'outlined',
            },
            gridColumnOptions: {
                formCol: 8
            }
        }, {
            label: "taxes.form.percent",
            keyName: "tax_percentage",
            Component: FormTextBox,
            disabled: isEdit,
            registerOptions:
            {
                required: true,
                validate: (value: any) => {
                    try {
                        const int = parseFloat(value);
                        const decimals = countDecimal(int);
                        if (decimals > 3) {
                            return "This can only be 3 decimals long";
                        }
                        return true;
                    } catch (error) {
                        return "This has to be a number";
                    }

                },
            },
            inputProperties: {
                variant: 'outlined',
                type: 'number',
                inputProps: { step: 0.001, min: 0 },
                InputProps: {
                    endAdornment: <InputAdornment position="end"><b>%</b></InputAdornment>
                },
            },
            gridColumnOptions: {
                formCol: 4
            }
        },
        {
            label: "taxes.form.type",
            Component: FormSelect,
            disabled: isEdit,
            registerOptions: {
                required: true
            },
            formProps: {
                selectOptions: [{
                    name: t('taxes.form.inclusive'),
                    value: ITaxType.INCLUSIVE,
                }, {
                    name: t('taxes.form.additive'),
                    value: ITaxType.ADDITIVE,
                }]
            },
            keyName: "tax_inclusion_type"
        },
        {
            label: "taxes.form.enabled",

            Component: FormSwitchWithText,
            formProps: {
                secondLabel: "taxes.form.enableSecondLabel",
                hasStatus: true,
            },
            keyName: "enabled",
        },
    ];
}

